import { Component, signal, OnInit, OnDestroy } from '@angular/core';
import { HeroV2Component } from './hero-v2.component';
import { ProofStripV2Component } from './proof-strip-v2.component';
import { AuthorityComponent } from './authority.component';
import { RiskV2Component } from './risk-v2.component';
import { NewsV2Component } from './news-v2.component';
import { HowItWorksV2Component } from './how-it-works-v2.component';
import { PackV2Component } from './pack-v2.component';
import { TestimonialsV2Component } from './testimonials-v2.component';
import { SegmentsV2Component } from './segments-v2.component';
import { FaqV2Component } from './faq-v2.component';
import { SimulatorV2Component } from './simulator-v2.component';
import { SimulatorPopupComponent } from './simulator-popup.component';
import { MetricsComponent } from './metrics.component';
import { FooterComponent } from './footer.component';
import { ModalComponent } from './modal.component';

@Component({
  selector: 'app-home-v2',
  standalone: true,
  imports: [
    HeroV2Component,
    ProofStripV2Component,
    AuthorityComponent,
    RiskV2Component,
    NewsV2Component,
    HowItWorksV2Component,
    PackV2Component,
    TestimonialsV2Component,
    SegmentsV2Component,
    FaqV2Component,
    SimulatorV2Component,
    SimulatorPopupComponent,
    MetricsComponent,
    ModalComponent,
    FooterComponent,
  ],
  template: `
    <main>
      <app-hero-v2></app-hero-v2>
      <app-proof-strip-v2></app-proof-strip-v2>
      <app-authority></app-authority>
      <app-risk-v2></app-risk-v2>
      <app-news-v2></app-news-v2>
      <app-how-it-works-v2></app-how-it-works-v2>
      <app-pack-v2></app-pack-v2>
      <app-testimonials-v2></app-testimonials-v2>
      <app-segments-v2></app-segments-v2>
      <app-faq-v2></app-faq-v2>
      <app-simulator-v2 (concluido)="onSimuladorConcluido()"></app-simulator-v2>
      <app-modal></app-modal>
      <app-metrics></app-metrics>
    </main>
    <app-footer></app-footer>
    @if (mostrarPopup()) {
      <app-simulator-popup (fechar)="fecharPopup()"></app-simulator-popup>
    }
  `
})
export class HomeV2Component implements OnInit, OnDestroy {
  mostrarPopup = signal(false);

  private popupJaExibido = false;
  private timerId: ReturnType<typeof setTimeout> | null = null;
  private scrollHandler: (() => void) | null = null;
  private exitHandler: ((e: MouseEvent) => void) | null = null;

  ngOnInit() {
    if (sessionStorage.getItem('beetrack_simulador_concluido')) return;

    this.timerId = setTimeout(() => this.abrirPopup(), 12000);

    this.scrollHandler = () => {
      const scrollavel = document.body.scrollHeight - window.innerHeight;
      if (scrollavel > 0 && window.scrollY / scrollavel >= 0.5) {
        this.abrirPopup();
      }
    };
    window.addEventListener('scroll', this.scrollHandler, { passive: true });

    const isDesktop = window.matchMedia('(pointer: fine) and (min-width: 768px)').matches;
    if (isDesktop) {
      this.exitHandler = (e: MouseEvent) => {
        if (e.clientY <= 0) this.abrirPopup();
      };
      document.addEventListener('mouseleave', this.exitHandler);
    }
  }

  ngOnDestroy() {
    this.removerGatilhos();
  }

  private abrirPopup() {
    if (this.popupJaExibido) return;
    if (sessionStorage.getItem('beetrack_simulador_concluido')) return;
    this.popupJaExibido = true;
    this.removerGatilhos();
    this.mostrarPopup.set(true);
  }

  private removerGatilhos() {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    if (this.exitHandler) {
      document.removeEventListener('mouseleave', this.exitHandler);
      this.exitHandler = null;
    }
  }

  fecharPopup() {
    this.mostrarPopup.set(false);
  }

  onSimuladorConcluido() {
    this.mostrarPopup.set(false);
  }
}
